import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pt-3" }
const _hoisted_2 = { class: "text-xl font-semibold" }
const _hoisted_3 = { class: "flex flex-column gap-5 pt-4" }
const _hoisted_4 = { class: "p-float-label error-label mb-4 mt-1" }
const _hoisted_5 = { for: "numberOfPoints" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex gap-1 align-items-center mt-3" }
const _hoisted_8 = { class: "line-height-1" }
const _hoisted_9 = { class: "p-float-label error-label mt-1" }
const _hoisted_10 = { for: "toUser" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "border-2 border-orange-500 bg-orange-50 border-round-xl p-3 mt-4" }
const _hoisted_13 = { class: "m-0 text-sm" }
const _hoisted_14 = { class: "verificationStatus" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_check-round icon" }, null, -1)
const _hoisted_16 = { class: "text text-center" }
const _hoisted_17 = { class: "text text-center text-lg" }
const _hoisted_18 = { class: "verificationStatus" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_alert icon" }, null, -1)
const _hoisted_20 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("my_points.transfer.title")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("my_points.transfer.amount_title")), 1),
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_InputNumber, {
              id: "numberOfPoints",
              name: "numberOfPoints",
              modelValue: _ctx.numberOfPoints,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.numberOfPoints) = $event)),
              disabled: _ctx.transferAll,
              max: _ctx.loyaltyPoints,
              class: "w-full"
            }, null, 8, ["modelValue", "disabled", "max"]),
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("my_points.transfer.amount")), 1),
            (_ctx.pointsError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.pointsError), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.transferAll,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.transferAll) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("my_points.transfer.all")), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("my_points.transfer.email_title")), 1),
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_InputText, {
              id: "toUser",
              name: "toUser",
              modelValue: _ctx.toUser,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.toUser) = $event)),
              type: "text"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("my_points.transfer.email")), 1),
            (_ctx.emailError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.emailError), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: "defaultButton",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.transferPoints && _ctx.transferPoints(...args)))
      }, _toDisplayString(_ctx.$t("my_points.transfer.action")), 1),
      _createVNode(_component_router_link, {
        to: { name: 'MyPointsOverview' },
        class: "block no-underline mt-3"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("global.cancel")), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("my_points.transfer.warning_title")), 1),
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("my_points.transfer.warning")), 1)
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showSuccessDialog,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showSuccessDialog) = $event)),
      modal: "",
      draggable: false,
      class: "successDialog",
      onHide: _ctx.closeSuccessDialog
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("my_points.transfer.success")), 1),
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.calculatePoints()), 1)
        ]),
        _createVNode(_component_Button, {
          class: "defaultButton",
          onClick: _ctx.closeSuccessDialog,
          style: {"justify-content":"center"},
          onKeypress: _withKeys(_ctx.closeSuccessDialog, ["enter"]),
          tabindex: "0"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("dialog.close")), 1)
          ]),
          _: 1
        }, 8, ["onClick", "onKeypress"])
      ]),
      _: 1
    }, 8, ["visible", "onHide"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showErrorDialog,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showErrorDialog) = $event)),
      modal: "",
      draggable: false,
      class: "successDialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("my_points.transfer.error")), 1)
        ]),
        _createVNode(_component_Button, {
          class: "defaultButton",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showErrorDialog = false)),
          style: {"justify-content":"center"},
          onKeypress: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.showErrorDialog = false), ["enter"])),
          tabindex: "0"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("dialog.close")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}